import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

function SpinningWheel() {
  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "10rem",
      }}
    >
      <CircularProgress size={80} color="primary" />;
    </div>
  );
}

export default SpinningWheel;
